<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="width + 50">
      <v-card>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>

        <v-card-text>
          <center>

            <v-img
            v-if="type == 'image'"
            :src="url"
            :lazy-src="url"
            alt="Imagem"
            class="grey lighten-2"
            :width="453"
            :height="642"
          >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <video v-else-if="type == 'video'" :width="width" controls>
            <source :src="url">
            Seu navegador não suporta video tag.
          </video>

          <iframe v-else-if="type == 'pdf'" :src="url" frameborder="0" :width="width" :height="height"></iframe>

          <div v-else>
            Não Suportado
          </div>

          </center>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" outlined rounded small @click="close()">
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'DialogViewImage',

  props: {
    width: {
      type: Number,
      default: 700
    },

    height: {
      type: Number,
      default: 600
    }
  },

  data() {
    return {
      dialog: false,
      title: '',
      url: '',
      type: ''
    }
  },

  methods: {
    show(dialog, title, type, url) {
      this.dialog = dialog
      this.title = title
      this.type = type
      this.url = url
    },

    close() {
      this.dialog = false
      this.title = ''
      this.type = ''
      this.url = ''
    }
  }
}
</script>
